var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("app-side-menu", { attrs: { "min-width": 18, "fixed-menu": false } }, [
        _c(
          "aside",
          {
            staticClass: "menu",
            attrs: { slot: "side-menu" },
            slot: "side-menu",
          },
          [
            _c("div", { staticClass: "menu-label" }, [
              _c("div", { staticClass: "columns is-gapless" }, [
                _c("div", { staticClass: "column" }, [
                  _c(
                    "span",
                    {
                      staticClass: "title is-6",
                      staticStyle: { "white-space": "nowrap" },
                    },
                    [_vm._v(" Quote No: " + _vm._s(_vm.entityName) + " ")]
                  ),
                ]),
              ]),
            ]),
            _c("ul", { staticClass: "menu-list" }, [
              _c(
                "li",
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: {
                          name: _vm.routeTypes.MiscQuoteDetail.name,
                          params: { quoteId: _vm.$route.params.quoteId },
                          query: _vm.$route.query,
                        },
                        "active-class": "is-active",
                        exact: "",
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          class: {
                            "has-badge-danger has-badge-small has-badge-rounded":
                              _vm.$v.detailGroup.$error,
                          },
                          attrs: {
                            "data-badge": _vm.$v.detailGroup.$error ? "" : null,
                          },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "has-badge-child-offset2" },
                            [_vm._v("Details")]
                          ),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "li",
                [
                  _c(
                    "router-link",
                    {
                      class: { "is-disabled": _vm.enableItemRoutes },
                      attrs: {
                        to: {
                          name: _vm.routeTypes.MiscQuoteInvoice.name,
                          params: { quoteId: _vm.$route.params.quoteId },
                          query: _vm.$route.query,
                        },
                        "active-class": "is-active",
                        event: "",
                        exact: "",
                      },
                      nativeOn: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.goToRoute({
                            name: _vm.routeTypes.MiscQuoteInvoice.name,
                            params: { quoteId: _vm.$route.params.quoteId },
                            query: _vm.$route.query,
                          })
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "has-badge-child-offset3" }, [
                        _vm._v("Invoice"),
                      ]),
                      _vm.invoice
                        ? _c("span", {
                            staticClass: "has-badge-rounded has-badge-medium",
                            class: [
                              _vm.$v.entity.invoices.$error
                                ? "has-badge-danger has-badge-icon-exclamation"
                                : _vm.invoice.isNew
                                ? "has-badge-icon-check has-badge-gold"
                                : "has-badge-icon-check has-badge-success",
                            ],
                            attrs: { "data-badge": "" },
                          })
                        : _vm._e(),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _c("p", { staticClass: "menu-label" }, [_vm._v(" Items ")]),
            _c("ul", { staticClass: "menu-list" }, [
              _c(
                "li",
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: {
                          name: _vm.routeTypes.MiscQuoteItems.name,
                          params: { quoteId: _vm.$route.params.quoteId },
                          query: _vm.$route.query,
                        },
                        "active-class": "is-active",
                        exact: "",
                      },
                    },
                    [
                      _c("span", [
                        _c("span", [
                          _c(
                            "span",
                            { staticClass: "has-badge-child-offset3" },
                            [_vm._v("Items")]
                          ),
                          _c("span", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.value.items,
                                expression: "value.items",
                              },
                            ],
                            staticClass: "has-badge-rounded has-badge-medium",
                            class: [
                              _vm.$v.entity.items.$error
                                ? "has-badge-danger"
                                : "has-badge-info",
                            ],
                            attrs: {
                              "data-badge": _vm.value.items.filter(
                                (i) => !i.isDeleted
                              ).length,
                            },
                          }),
                        ]),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }